import type { ReactElement } from 'react'

import { SortingDirection } from './Sorting'

export interface TableContents {
    column: Column[]
    rows: Row[]
}

export interface Column {
    /** ID is automatically set in the provider, it is required for sticky columns. Custom ID can be set for each column, but it has to be unique */
    id?: string | number
    alignment?: 'start' | 'center' | 'end'
    hasNoPadding?: boolean
    isActionColumn?: boolean
    isStretched?: boolean
    lineWrapping?: 0 | 1 | 2
    sortBy?: string
    sortDirection?: SortingDirection
    filterBy?: string
    title?: string | React.ReactNode
    isCollapseColumn?: boolean
    sticky?: 'left' | 'right' | 'left-borderless' | 'right-borderless'
    tooltip?: string | React.ReactNode
}

export interface Row {
    column: string
    cell: ReactElement | string
    class: string
}

export enum TableHeaderVariants {
    REGULAR = 'regular',
    QUIET = 'quiet',
}

export enum TableVariants {
    STRETCHED = 'stretched',
    INLINE = 'inline',
}

export enum TableSizes {
    SMALL = 'small',
    MEDIUM = 'medium',
    LARGE = 'large',
}

export interface ColumnInformation {
    position: 'left' | 'right'
    width: number
}
